import { render, staticRenderFns } from "./customTitle.vue?vue&type=template&id=448715bd&scoped=true&"
import script from "./customTitle.vue?vue&type=script&lang=js&"
export * from "./customTitle.vue?vue&type=script&lang=js&"
import style0 from "./customTitle.vue?vue&type=style&index=0&id=448715bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448715bd",
  null
  
)

export default component.exports